import {FC, useContext, useEffect} from 'react';
import Item from './Item';
import {FiltersContext} from "../Context/FiltersContext.tsx";
import { useItems } from '../Hooks/useItems.ts'
import useFilterHandlers from "../Hooks/useFilterHandlers.ts";
import {APP} from '../Utils/Constants.ts'
import Pager from './Pager.tsx'
import Result from "./Result.tsx";

interface ItemsProps {
  type_formation: TaxonomyTerm[];
}

const Items: FC<ItemsProps> = ({ type_formation}) => {
    const {filterParams}  =  useContext(FiltersContext);

    const { items, itemsStatus, nbrItem } = useItems(APP.NUMBER_PRODUCT_BY_PAGE, filterParams);


  const { handleFilter,
    // handleFilterArray,
    getFilterValue } = useFilterHandlers();

    useEffect(() => {
    }, [itemsStatus]);

    const typeFormationMap: { [key: string]: string } = {};

    type_formation.forEach(type => {
        typeFormationMap[type.attributes.drupal_internal__tid] = type.attributes.name;
    });

    if (items.length > 0) {
      return (
          <>
              <Result count={nbrItem}/>
              <div className="catalog-list__wrapper">
                  <ul className="catalog-list__items">
                      {items.map(item => (
                          // @ts-expect-error item is loosely typed by useItems()
                          <li key={`formation-item-${item.product_id}`}>
                              <Item
                                  type_formation={typeFormationMap}
                                  item={item}
                              />
                          </li>
                      ))}
                  </ul>
              </div>
              <Pager nbrItem={nbrItem} handlePage={handleFilter} value={getFilterValue("page")}></Pager>
          </>
        );
    } else {
        return(
          <>
            <Result count={nbrItem}/>
          </>
        )
    }
};

export default Items;
